
import { Component, Vue } from 'nuxt-property-decorator'
import ClientsFeedback from '@/components/sections/clients-feedback/ClientsFeedback.vue'

@Component({
  components: {
    ClientsFeedback,
  },
})
export default class BlackFridayClientFeedback extends Vue {}
